// extracted by mini-css-extract-plugin
export default {"errorText":"styles_errorText__WY601","faultCode":"styles_faultCode__K0jBQ"};